import { optimism as viemOptimism } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const optimism = {
  displayName: 'Optimism',
  runtime: 'evm',
  viemChain: viemOptimism,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 5,

  decoration: {
    color: '#FF0420',
    contrastColor: getContrastColor('#FF0420'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'optimism',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://optimistic.etherscan.io',
        token: 'https://optimistic.etherscan.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '10',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'OPT' },
    stargate: { chainKey: 'optimism' },
    across: { chainKey: 'optimism' },
    xswap: { chainKey: '10' },
    okx: { chainKey: '10' },
    kyberswap: { chainKey: 'optimism' },
    houdini: { chainKey: 'OP' },
  }),
  services: defaultServices({
    codex: {
      networkId: 10,
      nativeLiquidityAddress: '0x4200000000000000000000000000000000000006',
    },
    defiLlama: { chainKeys: ['optimism'] },
    trm: { chainKey: 'optimism' },
    zerion: { chainKey: 'optimism' },
    coingecko: {
      networkId: 'optimism',
      platformId: 'optimistic-ethereum',
    },
    coingeckoDex: {
      networkId: 'optimism',
    },
    qnStreams: {
      networkKey: 'optimism-mainnet',
    },
    safe: { shortName: 'oeth' },
    alchemy: { chainSlug: 'opt-mainnet' },
    pimlico: { chainSlug: 'optimism' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
